import { render, staticRenderFns } from "./NIHSSMotor.vue?vue&type=template&id=ada2a2dc&"
import script from "./NIHSSMotor.vue?vue&type=script&lang=ts&"
export * from "./NIHSSMotor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ada2a2dc')) {
      api.createRecord('ada2a2dc', component.options)
    } else {
      api.reload('ada2a2dc', component.options)
    }
    module.hot.accept("./NIHSSMotor.vue?vue&type=template&id=ada2a2dc&", function () {
      api.rerender('ada2a2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standalone/NIHSSMotor.vue"
export default component.exports